var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[[_c('label',{staticClass:"block border-2 cursor-pointer"},[_c('div',{staticClass:"text-gray-800 text-base p-3 flex items-center"},[_vm._v("\n          New brokers per week\n          \n          "),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-brokers-per-week',
              params: {
                year : 2019
              }
            },"tag":"a"}},[_vm._v("2019")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-brokers-per-week',
              params: {
                year : 2020
              }
            },"tag":"a"}},[_vm._v("2020")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-brokers-per-week',
              params: {
                year : 2021
              }
            },"tag":"a"}},[_vm._v("2021")])],1)]),_c('label',{staticClass:"block border-2 mt-2 cursor-pointer"},[_c('div',{staticClass:"text-gray-800 text-base p-3 flex items-center"},[_vm._v("\n          New clients per week\n          \n          "),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-clients-per-week',
              params: {
                year : 2019
              }
            },"tag":"a"}},[_vm._v("2019")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-clients-per-week',
              params: {
                year : 2020
              }
            },"tag":"a"}},[_vm._v("2020")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
              name  : 'metric-new-clients-per-week',
              params: {
                year : 2021
              }
            },"tag":"a"}},[_vm._v("2021")])],1)]),_c('label',{staticClass:"block border-2 mt-2 cursor-pointer"},[_c('div',{staticClass:"text-gray-800 text-base p-3 flex items-center"},[_vm._v("\n          Emails sent to clients per week\n           \n          "),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-to-clients-per-week',
            params : {
              year : 2019
            }
          },"tag":"a"}},[_vm._v("2019")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-to-clients-per-week',
            params : {
              year : 2020
            }
          },"tag":"a"}},[_vm._v("2020")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-to-clients-per-week',
            params : {
              year : 2021
            }
          },"tag":"a"}},[_vm._v("2021")])],1)]),_c('label',{staticClass:"block border-2 mt-2 cursor-pointer"},[_c('div',{staticClass:"text-gray-800 text-base p-3 flex items-center"},[_vm._v("\n          Emails sent from clients per week\n\n          "),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-from-clients-per-week',
            params : {
              year : 2019
            }
          },"tag":"a"}},[_vm._v("2019")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-from-clients-per-week',
            params : {
              year : 2020
            }
          },"tag":"a"}},[_vm._v("2020")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-emails-from-clients-per-week',
            params : {
              year : 2021
            }
          },"tag":"a"}},[_vm._v("2021")])],1)]),_c('label',{staticClass:"block border-2 mt-2 cursor-pointer"},[_c('div',{staticClass:"text-gray-800 text-base p-3 flex items-center"},[_vm._v("\n          Stripe subscriptions per week\n\n          "),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-stripe-subscriptions-per-week',
            params : {
              year : 2019
            }
          },"tag":"a"}},[_vm._v("2019")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-stripe-subscriptions-per-week',
            params : {
              year : 2020
            }
          },"tag":"a"}},[_vm._v("2020")]),_c('router-link',{staticClass:"underline ml-8",attrs:{"to":{
            name: 'metric-stripe-subscriptions-per-week',
            params : {
              year : 2021
            }
          },"tag":"a"}},[_vm._v("2021")])],1)])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }